import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { ConvertFb2ToEpubDialogProps } from './ConvertFb2ToEpubDialog';

export const openConvertFb2ToEpubDialog = (data: Omit<ConvertFb2ToEpubDialogProps, 'popupName'>) =>
    openPopupHelper({ popupName: popupNames.CONVERT_FB2_TO_EPUB, data });
